import { RPCs } from "../../../services/rpc.js";
import { SelectMultiOptionWrapper } from "../../../components/Select/SelectMultiOptionWrapper.js";
import { SelectAsyncRPC } from "../../../components/Select/SelectAsyncRPC.js";
import "react";
import { ColorSquare } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Reports/shared/SelectReportType.tsx
var SelectReportTypeRenderComponents = {
	ListItem: ({ color, name }) => /* @__PURE__ */ jsxs("div", {
		className: "inline-flex w-full items-center justify-between",
		children: [/* @__PURE__ */ jsx("div", {
			className: "gap-x-xs inline-flex items-end overflow-hidden",
			children: /* @__PURE__ */ jsx("span", {
				className: "truncate",
				children: name
			})
		}), !!color && /* @__PURE__ */ jsx(ColorSquare, { color })]
	}),
	SelectedMulti: ({ color, name }, onRemove) => /* @__PURE__ */ jsx(SelectMultiOptionWrapper, {
		onRemove,
		children: /* @__PURE__ */ jsxs("div", {
			className: "px-xs gap-x-xs inline-flex items-center overflow-hidden text-sm",
			children: [!!color && /* @__PURE__ */ jsx(ColorSquare, { color }), /* @__PURE__ */ jsx("div", {
				className: "truncate",
				children: name
			})]
		})
	}),
	SelectedSingle: ({ color, name }) => /* @__PURE__ */ jsxs("div", {
		className: "inline-flex w-full items-center justify-between",
		children: [/* @__PURE__ */ jsx("div", {
			className: "gap-x-xs inline-flex items-end overflow-hidden",
			children: /* @__PURE__ */ jsx("span", {
				className: "truncate",
				children: name
			})
		}), !!color && /* @__PURE__ */ jsx(ColorSquare, { color })]
	})
};
var responseOptionsExtractor = (data) => data?.reportTypes;
var SelectReportType = ({ active, limit = 15, multi, organizationId, regionIds, reportTypeIds, value, ...atalayaSelectProps }) => {
	return /* @__PURE__ */ jsx(SelectAsyncRPC, {
		RenderListItem: SelectReportTypeRenderComponents.ListItem,
		RenderSelectedSingle: SelectReportTypeRenderComponents.SelectedSingle,
		RenderSelectedMulti: SelectReportTypeRenderComponents.SelectedMulti,
		args: {
			active,
			organizationId,
			regionIds,
			reportTypeIds
		},
		idProp: "id",
		limit,
		multi,
		optionLabelExtractor: ({ name }) => name,
		optionValueExtractor: ({ id }) => id,
		request: RPCs.Reports.GetReportTypesList.v1,
		requestFilterProp: "reportTypeIds",
		responseOptionsExtractor,
		value,
		...atalayaSelectProps
	});
};
//#endregion
export { SelectReportType, SelectReportTypeRenderComponents };

//# sourceMappingURL=SelectReportType.js.map